import { render, staticRenderFns } from "./info-message.vue?vue&type=template&id=217a7bda"
import script from "./info-message.vue?vue&type=script&lang=js"
export * from "./info-message.vue?vue&type=script&lang=js"
import style0 from "./info-message.vue?vue&type=style&index=0&id=217a7bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzIconCross: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/icons/icon-cross/index.vue').default,RzContainer: require('/opt/iaravia.ru/node_modules/@razlet/ui/src/components/container/index.vue').default})
